export const UPDATE_SMS_COUNTER = 'update_sms_counter';
export const LOCAL_SMS = 'local_sms';
export const SET_SMS_COUNTER = 'set_sms_counter';
